/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

import {
  Wrapper,
  BTNIcon,
  DownloadIconStlyed,
  BTNStyle,
  MenuStyled,
  MenuItemStyled,
  LabelStyled,
  LabelSugestion,
  DownloadText,
} from './styles';

const SheetDownload = ({
  exportXLS,
  exportDetailedXLS,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Wrapper>
      <DownloadText onClick={handleClick}>Baixar Lista</DownloadText>
      <BTNStyle
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <BTNIcon />
      </BTNStyle>
      <MenuStyled
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItemStyled
          onClick={() => {
            exportXLS();
            handleClose();
          }}
        >
          <DownloadIconStlyed />
          <LabelStyled component="span">
            Baixar lista compacta (.xlsx)
          </LabelStyled>
        </MenuItemStyled>
        <MenuItemStyled
          onClick={() => {
            exportDetailedXLS();
            handleClose();
          }}
        >
          <DownloadIconStlyed />
          <LabelStyled component="span">
            Baixar lista detalhada (.xlsx)
          </LabelStyled>
        </MenuItemStyled>
      </MenuStyled>
    </Wrapper>
  );
};

export default SheetDownload;
